import "./_pagenotfound.scss";

export default function PageError(){
  return (
    <div id="pagenotfound">
      <h1>ERRO 500</h1>
      <h2>Internal server error</h2>
      <h6>Há um problema com o recurso que você está procurando e ele não pode ser exibido.</h6>
    </div>
  );
}